// Pregoeiros Summit 2027 · Florianópolis/SC · dados centrais do evento

export const EVENT = {
  name: "Pregoeiros Summit 2027",
  edition: "PS27 FLORIPA",
  startDate: "2027-03-03T08:00:00-03:00",
  endDate: "2027-03-05T18:00:00-03:00",
  dateLabel: "03, 04 e 05 de Março de 2027",
  dateShort: "03 a 05 de Março",
  year: "2027",
  city: "Florianópolis",
  state: "SC",
  venue: "Oceania Park Hotel Spa & Convention Center",
  venueAddress: "Praia dos Ingleses · Florianópolis/SC",
  contactEmail: "pregoeirossummit@ceapbrasil.com",
  website: "www.pregoeirossummit.com.br",
};

export const STATS = [
  { value: "03", suffix: "", label: "dias de imersão", sub: "03 a 05 de março" },
  { value: "26", suffix: "+", label: "horas de conteúdo", sub: "prático e aplicável" },
  { value: "500", suffix: "+", label: "órgãos públicos", sub: "representados nas edições" },
  { value: "08", suffix: "", label: "autoridades", sub: "confirmadas no lineup" },
];

export const SPEAKERS_2027 = [
  { name: "Joel de Menezes Niebuhr", short: "Joel Niebuhr", role: "Doutor em Direito Administrativo", photo: "/speakers/joel-niebuhr.webp", photoPosition: "center top" },
  { name: "Antonio Anastasia", short: "Antonio Anastasia", role: "Ministro do TCU", photo: "/speakers/antonio-anastasia.webp", photoPosition: "center top" },
  { name: "Vinícius Geronasso", short: "Vinícius Geronasso", role: "Especialista em Gestão Pública", photo: "/speakers/vinicius-geronasso.webp", photoPosition: "center top" },
  { name: "Fabrício Mareco", short: "Fabrício Mareco", role: "Auditor Federal · TCU", photo: "/speakers/fabricio-mareco.webp", photoPosition: "center top" },
  { name: "Jamil Manasfi", short: "Jamil Manasfi", role: "Especialista em Licitações", photo: "/speakers/jamil-manasfi.webp", photoPosition: "center top" },
  { name: "Lara Brainer", short: "Lara Brainer", role: "Coord. Geral Governança e Estratégia · AGU", photo: "/speakers/lara-brainer.webp", photoPosition: "center top" },
  { name: "Leandro Matsumota", short: "Leandro Matsumota", role: "Especialista em Licitações e Contratos", photo: "/speakers/leandro-matsumota.webp", photoPosition: "center top" },
  { name: "Jader Esteves", short: "Jader Esteves", role: "Especialista em Licitações", photo: "/speakers/jader-esteves.webp", photoPosition: "center top" },
  { name: "Carolina Zancaner", short: "Carolina Zancaner", role: "Procuradora da Fazenda Nacional", photo: "/speakers/carolina-zancaner.webp", photoPosition: "center top" },
  { name: "Felipe Dalenogare", short: "Felipe Dalenogare", role: "Pós-Doutor em Direito pela Università di Bologna", photo: "/speakers/felipe-dalenogare.webp", photoPosition: "center top" },
  { name: "Ketlin Feitosa", short: "Ketlin Feitosa", role: "Chefe da Assessoria de Gestão Sustentável do STJ", photo: "/speakers/ketlin-feitosa.webp", photoPosition: "center top" },
  { name: "Cristiane Fortini", short: "Cristiane Fortini", role: "Doutora em Direito", photo: "/speakers/cristiane-fortini.webp", photoPosition: "center top" },
  { name: "Michelle Marry", short: "Michelle Marry", role: "Advogada da União · AGU", photo: "/speakers/michelle-marry.webp", photoPosition: "center top" },
  { name: "Antonio Netto", short: "Antonio Netto", role: "Especialista em IA e Contratações", photo: "/speakers/antonio-netto.webp", photoPosition: "center top" },
  { name: "André Oliveira", short: "André Oliveira", role: "Diretor executivo do CINCATARINA", photo: "/speakers/andre-oliveira.webp", photoPosition: "center top" },
  { name: "Marilene Matos", short: "Marilene Matos", role: "Doutora em Direito", photo: "/speakers/marilene-matos.webp", photoPosition: "center top" },
  { name: "César Wanderley", short: "César Wanderley", role: "Doutorando em Direito", photo: "/speakers/cesar-wanderley.webp", photoPosition: "center top" },
  { name: "Gustavo Shiefler", short: "Gustavo Shiefler", role: "Doutor em Direito", photo: "/speakers/gustavo-shiefler.webp", photoPosition: "center top" },
  { name: "Rafael Oliveira", short: "Rafael Oliveira", role: "Procurador Municipal", photo: "/speakers/rafael-oliveira.webp", photoPosition: "center top" },
];

// Lotes do ingresso presencial
const LOT1_DEADLINE = new Date("2026-12-30T23:59:59-03:00");
export const IS_FIRST_LOT = Date.now() < LOT1_DEADLINE.getTime();

export const PLANS = [
  {
    id: "presencial",
    name: "Presencial",
    badge: IS_FIRST_LOT ? "LOTE PROMOCIONAL · ATÉ 30/12/2026" : "LOTE 2 · VALOR ATUAL",
    price: IS_FIRST_LOT ? "R$ 4.797" : "R$ 5.797",
    priceValue: IS_FIRST_LOT ? 4797 : 5797,
    priceNote: IS_FIRST_LOT ? "Após 30/12/2026 o valor passa para R$ 5.797" : "Lote promocional foi R$ 4.797 até 30/12/2026",
    desc: "A experiência completa ao vivo, em Florianópolis. Ideal para quem quer mergulhar nos 3 dias de conteúdo e fazer conexões estratégicas.",
    highlight: true,
    benefits: [
      "Acesso integral aos 3 dias do evento",
      "Kit oficial Pregoeiros Summit",
      "Livro 9ª edição “Licitação Pública e Contrato Administrativo” · Joel de Menezes Niebuhr · Editora Fórum",
      "Almoço incluso nos três dias de evento",
      "Welcome coffee nos três dias (manhãs)",
      "Coffee break nos três dias (tardes)",
    ],
  },
  {
    id: "online",
    name: "Online · Ao Vivo",
    badge: "DE QUALQUER LUGAR",
    price: "R$ 2.190",
    priceValue: 2190,
    priceNote: "Transmissão ao vivo dos 3 dias",
    desc: "Acompanhe tudo ao vivo, de onde estiver, e revise o conteúdo por 12 meses na plataforma.",
    highlight: false,
    benefits: [
      "Transmissão ao vivo em alta definição dos 3 dias",
      "Acesso de 12 meses à plataforma EAD para rever todas as palestras",
      "Apostila digital em PDF",
      "Certificado digital de conclusão (20h+)",
      "Suporte técnico durante o evento",
    ],
  },
];

export const GROUP_DISCOUNT_TIERS = [
  { min: 4, max: 6, pct: 10 },
  { min: 7, max: 9, pct: 15 },
  { min: 10, max: Infinity, pct: 20 },
];
export const GROUP_DISCOUNT_MIN = 4;

export const DIFF_CONTENT = [
  "10 Palestras",
  "09 Workshops Simultâneos",
  "Painéis temáticos",
  "Debates com participação ativa dos participantes",
];

export const DIFF_EXPERIENCE = [
  "Show de abertura",
  "Almoço em todos os dias de evento",
  "Kit Oficial PS27",
  "Welcome coffee em todos os dias de evento",
  "Coffee Break em todas as tardes",
  "Prêmio CEAP BRASIL de excelência em licitações",
  "Sala do Pregoeiro para consultorias individuais",
];

export const KIT_IMAGE = "/kit-ps27.webp";

export const DIFF_IMAGES = {
  content: "/diff-content.jpg",
  experience: "https://customer-assets.emergentagent.com/job_summit-licitacoes-rj/artifacts/ue7hb5ap_MAU04261%20%281%29.jpg",
};

export const FOLDER_URL = "https://customer-assets.emergentagent.com/job_summit-licitacoes-rj/artifacts/0jan90sc_Folder%20Pregoeiros%20Summit%20RJ%202026%20%284%29.pdf";

export const FAQ = [
  {
    q: "Por que eu deveria participar do Pregoeiros Summit 2027?",
    a: "É a oportunidade de aprender diretamente com as maiores autoridades em licitações e contratos do país e fazer networking com pregoeiros e gestores de todo o Brasil. Um insight ou um aperto de mão podem mudar completamente o jogo da sua carreira e do seu órgão.",
  },
  {
    q: "Quando e onde será o evento?",
    a: "O Pregoeiros Summit 2027 acontece nos dias 03, 04 e 05 de março de 2027, no Oceania Park Hotel Spa & Convention Center, a 100 metros da Praia dos Ingleses, em Florianópolis · SC.",
  },
  {
    q: "Qual a diferença entre o ingresso Presencial e o Online?",
    a: "O Presencial dá acesso integral aos 3 dias de evento em Florianópolis, com kit oficial, livro físico autografável, almoço, welcome coffee e coffee breaks inclusos. O Online oferece a transmissão ao vivo em alta definição, 12 meses de acesso à plataforma EAD, apostila digital e certificado.",
  },
  {
    q: "O que está incluso no ingresso Presencial?",
    a: "Acesso integral aos 3 dias, kit oficial (credencial, mochila, squeeze, apostila impressa e brindes), o livro 9ª edição “Licitação Pública e Contrato Administrativo” de Joel de Menezes Niebuhr (Editora Fórum), almoço nos três dias, welcome coffee pelas manhãs e coffee breaks às tardes.",
  },
  {
    q: "Eu vou conseguir aplicar o que será ensinado?",
    a: "Sim. Nossa premissa é: só ensinamos o que você e sua equipe são capazes de aplicar imediatamente. Os palestrantes vivem na prática, todos os dias, o que ensinam. Por isso trazem soluções reais para os problemas reais do pregoeiro.",
  },
  {
    q: "Existe desconto para grupos?",
    a: "Sim. Órgãos e empresas que inscrevem equipes a partir de 4 pessoas têm condições especiais. Preencha o formulário de inscrição informando a quantidade ou fale com nosso time pelo WhatsApp.",
  },
  {
    q: "O evento emite certificado?",
    a: "Sim. Todos os participantes, presenciais e online, recebem certificado digital de conclusão com carga horária de 20h+.",
  },
];

// Galeria · edições anteriores (otimizadas localmente em /public/gallery)
export const GALLERY = [
  "/gallery/ps-1.webp",
  "/gallery/ps-2.webp",
  "/gallery/ps-3.webp",
  "/gallery/ps-4.webp",
  "/gallery/ps-5.webp",
  "/gallery/ps-6.webp",
  "/gallery/ps-7.webp",
];

export const LOGO_MARK = "/logo-mark.png";

export const YOUTUBE_ID = "Y6EZVwvktF8";
export const YOUTUBE_START = 52;

// Poster de fundo do hero (fallback caso o YouTube esteja inacessível)
export const HERO_POSTER = "https://customer-assets.emergentagent.com/job_summit-licitacoes-rj/artifacts/ue7hb5ap_MAU04261%20%281%29.jpg";

export const CEAP_LOGO = "https://customer-assets.emergentagent.com/job_summit-licitacoes-rj/artifacts/81gvnw5o_nova_logo_CEAP_2020-removebg-preview.png";

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/pregoeiros_summit/",
  linkedin: "https://www.linkedin.com/company/pregoeiros-summit/",
};

export const WHATSAPP_NUMBER = "5541996357515"; // (41) 99635-7515
export const WHATSAPP_DISPLAY = "(41) 99635-7515";
export const WHATSAPP_MESSAGE = "Olá! Vi a página do Pregoeiros Summit 2027 em Florianópolis e quero garantir minha vaga.";
